import styled from "styled-components";
import { TextField, Grid } from "@material-ui/core";

export const STDigitsWrapper = styled.div`
  width: 279px;
  margin-bottom: 30px;
`;

export const STTextField = styled(TextField).attrs({})`
  && {
    margin-bottom: 20px;
  }
`;

export const STLocationGrid = styled.div`
  && {
    padding-top: 15px;
    padding-left: 20px;
    padding-right: 20px;
  }
`;